module.exports = __webpack_public_path__ + "fonts/Brusher-2.63842e15.otf";